<template>
    <div class="bg-white px-3" style="margin: -20px;margin-bottom: 0!important;">
        <el-alert   type="info">
            <template slot="title">
                <div>
                  审核通过数 （{{successCount}}）
                </div>
            </template>
        </el-alert>
        <el-table :data="tableData" border v-loading="loading" :height="heights">
            <el-table-column prop="InvitationRecordDoctorAudit.real_name" label="被邀请人"> </el-table-column>
            <el-table-column prop="InviterDoctorAudit.real_name" label="邀请人"> </el-table-column>
            <el-table-column prop="InvitationRecordDoctorAudit.examine_text" label="审核状态"></el-table-column>
            <el-table-column label="审核开始时间" width="220" prop="create_time" ></el-table-column>
        </el-table>
        <div class="u-f u-ac u-jsb ft_mr">
            <div></div>
            <div>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper" :total="count">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tableData: [],
                pagesize: 15,
                currentPage: 1,
                count: 0,
                loading: false,
                heights:null,
                successCount:0,
            }
        },
        mounted() {
            this.getHeight()
            this.begin()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                that.heights = window.innerHeight - 200 + 'px'
                window.onresize = () => {
                    that.heights = window.innerHeight  - 200 + 'px'
                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios.post("/admin/DoctorInvitationRecord/InvitationRecord", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.total_count
                        that.successCount=response.data.data.success_count
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
        }
    }
</script>

<style>

</style>